module.exports = __webpack_public_path__ + "static/wildfork-logo-987dbad6e94a09f8c08bca504e5604cc.png";